export const TOGGLE_DOCSIS_VERSION = 'TOGGLE_DOCSIS_VERSION';

export const setDocsisVersion = docsisVersion => ({
  type: TOGGLE_DOCSIS_VERSION,
  value: {docsisVersion},
});
